import React, { useRef, useState } from 'react';
import { CustomRegister } from '../components';
import BottomNavigation from '../navigation/BottomNavigation';
import TopNavigation from '../navigation/TopNavigation';
import { Toast } from 'primereact/toast';

export const Register = (props) => {
    const toast = useRef(null);

    const [userType, setUserType] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [webSite, setWebSite] = useState('');


    const [companyType, setCompanyType] = useState();
    const [companyName, setCompanyName] = useState('');
    const [title, setTitle] = useState('');
    const [companyWebSite, setCompanyWebSite] = useState('');
    
    const [address, setAddress] = useState('');

    const [companyTypes, setCompanyTypes] = useState([]);
    const [selectedCompanyType, setSelectedCompanyType] = useState();

    const [contacts, setContacts] = useState([]);



    return (

        <div className='root-landing'>
            <Toast ref={toast} />

            <div className="grid grid-nogutter surface-login-main p-2" >

                <TopNavigation {...props} />
                <BottomNavigation {...props} />

                <div className="container-fluid" style={{ maxWidth: 650 }}>
                    <CustomRegister toast={toast}  {...props}
                        userType={userType} setUserType={setUserType}
                        firstName={firstName} setFirstName={setFirstName}
                        lastName={lastName} setLastName={setLastName}
                        email={email} setEmail={setEmail}
    
                        webSite={webSite} setWebSite={setWebSite}
    
                        companyType={companyType} setCompanyType={setCompanyType}
                        companyName={companyName} setCompanyName={setCompanyName}
                        title={title} setTitle={setTitle}
                        companyWebSite={companyWebSite} setCompanyWebSite={setCompanyWebSite}
                        companyTypes={companyTypes} setCompanyTypes={setCompanyTypes}
                        selectedCompanyType={selectedCompanyType} setSelectedCompanyType={setSelectedCompanyType}
                        contacts={contacts} setContacts={setContacts}

                    ></CustomRegister>
                </div>
            </div>
        </div>

    );
};
